module.exports = __webpack_public_path__ + "static/media/democrat.26bef2f8.svg";